// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".easCombobox-crL\\+m {\n  background: #fff;\n  border: 2px solid #dedce0;\n  border-radius: 4px;\n  box-shadow: none;\n  color: #333333;\n  display: inline-table;\n  line-height: 1;\n  outline: none;\n  padding: 0;\n  position: relative;\n  height: 50px;\n  width: auto;\n  max-width: 600px;\n  z-index: 1;\n}\n.easCombobox-crL\\+m:focus, .easCombobox-crL\\+m.active-\\+r8G4 {\n  border-color: #287ec7;\n}\n.easCombobox-crL\\+m.disabled-NPbUi {\n  background: #eee;\n  opacity: 0.65;\n}\n.easCombobox-crL\\+m.disabled-NPbUi:hover, .easCombobox-crL\\+m.disabled-NPbUi:focus {\n  border-color: #dedce0 !important;\n}\n.easCombobox-crL\\+m.disabled-NPbUi select {\n  cursor: not-allowed;\n}\n.easCombobox-crL\\+m.notValid-olrHX {\n  margin-bottom: 15px;\n  border-color: #a94442 !important;\n}\n.easCombobox-crL\\+m select {\n  cursor: pointer;\n  background: transparent !important;\n  padding: 0 30px 0 15px !important;\n  position: relative;\n  outline: none !important;\n  border: none !important;\n  box-shadow: none !important;\n  color: #333333;\n  font-size: 15px;\n  line-height: 46px;\n  height: 46px;\n  width: 100%;\n  max-width: inherit;\n  min-width: 125px;\n  -ms-overflow-style: auto;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n.easCombobox-crL\\+m select::-ms-expand {\n  display: none;\n}\n.easCombobox-crL\\+m select:focus {\n  border: none !important;\n  box-shadow: none;\n}\n.easCombobox-crL\\+m select[disabled] {\n  opacity: 1 !important;\n}\n.easCombobox-crL\\+m select:focus::-ms-value {\n  background-color: transparent;\n}\n.easCombobox-crL\\+m:before {\n  box-sizing: border-box;\n  color: #333333;\n  display: block;\n  font-family: 'FontAwesome';\n  font-size: 13px;\n  line-height: 50px;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  text-align: center;\n  width: 30px;\n  cursor: pointer;\n  transition: all 0.4s ease 0s;\n  content: '\\F0D7';\n}\n.easCombobox-crL\\+m select:focus::-ms-value {\n  color: #333333;\n}\n@media (max-width: 1600px) {\n  .easCombobox-crL\\+m select {\n    min-width: 225px;\n  }\n}\n:-moz-any(.easCombobox-crL\\+m):before {\n  pointer-events: none;\n  z-index: 1;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/form-controls/drop-downs/stateless-drop-down/drop-down.less"],"names":[],"mappings":"AAKA;EAEI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EAEA,YAAA;EACA,WAAA;EACA,gBAAA;EAEA,UAAA;AA6GJ;AA3GI;EAEE,qBAAA;AA6GN;AA1GI;EACE,gBAAA;EACA,aAAA;AA4GN;AA1GM;EAEE,gCAAA;AA4GR;AAlHI;EAUI,mBAAA;AA2GR;AAvGI;EACE,mBAAA;EACA,gCAAA;AAyGN;AAjJA;EA4CM,eAAA;EACA,kCAAA;EACA,iCAAA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;AAwGN;AAtGM;EACE,aAAA;AAwGR;AArGM;EACE,uBAAA;EACA,gBAAA;AAuGR;AApGM;EACE,qBAAA;AAsGR;AAnGM;EAEE,6BAAA;AAoGR;AAhGI;EACE,sBAAA;EACA,cAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;AAkGN;AAlMA;EAqGI,cAAA;AAgGJ;AA7FE;EAAA;IAEI,gBAAA;EA+FJ;AACF;AA1MA;EA+GI,oBAAA;EACA,UAAA;AA8FJ","sourcesContent":["@import '@cirrus/legacy/app-components/app/styles/font-size-variables.less';\n@import '@cirrus/legacy/app-components/app/styles/colors/colors-default';\n@import '@cirrus/legacy/app-components/app/styles/mixins';\n@import 'variables';\n\n:local {\n  .easCombobox {\n    background: #fff;\n    border: 2px solid @clr-gray-320;\n    border-radius: 4px;\n    box-shadow: none;\n    color: #333333;\n    display: inline-table;\n    line-height: 1;\n    outline: none;\n    padding: 0;\n    position: relative;\n\n    height: 50px;\n    width: auto;\n    max-width: 600px;\n\n    z-index: 1;\n\n    &:focus,\n    &.active {\n      border-color: @clr-blue-210;\n    }\n\n    &.disabled {\n      background: #eee;\n      opacity: 0.65;\n\n      &:hover,\n      &:focus {\n        border-color: @clr-gray-320 !important;\n      }\n\n      select {\n        cursor: not-allowed;\n      }\n    }\n\n    &.notValid {\n      margin-bottom: 15px;\n      border-color: #a94442 !important;\n    }\n\n    select {\n      cursor: pointer;\n      background: transparent !important;\n      padding: 0 30px 0 15px !important;\n      position: relative;\n      outline: none !important;\n      border: none !important;\n      box-shadow: none !important;\n      color: #333333;\n      font-size: 15px;\n      line-height: 46px;\n      height: 46px;\n      width: 100%;\n      max-width: inherit;\n      min-width: 125px;\n      -ms-overflow-style: auto;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n\n      &::-ms-expand {\n        display: none;\n      }\n\n      &:focus {\n        border: none !important;\n        box-shadow: none;\n      }\n\n      &[disabled] {\n        opacity: 1 !important;\n      }\n\n      &:focus::-ms-value {\n        // fixed ie blue selection\n        background-color: transparent;\n      }\n    }\n\n    &:before {\n      box-sizing: border-box;\n      color: #333333;\n      display: block;\n      font-family: 'FontAwesome';\n      font-size: 13px;\n      line-height: 50px;\n      padding: 0;\n      position: absolute;\n      top: 0;\n      right: 0;\n      text-align: center;\n      width: 30px;\n      cursor: pointer;\n      transition: all 0.4s ease 0s;\n      content: '\\F0D7';\n    }\n  }\n\n  .easCombobox select:focus::-ms-value {\n    color: #333333;\n  }\n\n  @media (max-width: 1600px) {\n    .easCombobox select {\n      min-width: 225px;\n    }\n  }\n\n  :-moz-any(.easCombobox):before {\n    pointer-events: none;\n    z-index: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitleFontSize": "22px",
	"pageTitleLineHeight": "55px",
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"easCombobox": "easCombobox-crL+m",
	"active": "active-+r8G4",
	"disabled": "disabled-NPbUi",
	"notValid": "notValid-olrHX"
};
export default ___CSS_LOADER_EXPORT___;
